import { PlaybookExecutionStatus } from '../api/playbooks/playbookExecution.model';
import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { ISelectOption } from './selectOption.interface';

export const PlaybookExecutionStatusSelectOptions: ISelectOption[] = [
  {
    id: `${FilterTypesEnum.ExecutionStatus}-${PlaybookExecutionStatus.success}`,
    value: PlaybookExecutionStatus.success,
    displayName: PlaybookExecutionStatus.success,
    filterType: FilterTypesEnum.ExecutionStatus,
    categoryName: FilterTypesEnum.ExecutionStatus,
  },
  {
    id: `${FilterTypesEnum.ExecutionStatus}-${PlaybookExecutionStatus.failure}`,
    value: PlaybookExecutionStatus.failure,
    displayName: PlaybookExecutionStatus.failure,
    filterType: FilterTypesEnum.ExecutionStatus,
    categoryName: FilterTypesEnum.ExecutionStatus,
  },
  {
    id: `${FilterTypesEnum.ExecutionStatus}-${PlaybookExecutionStatus.inProgress}`,
    value: PlaybookExecutionStatus.inProgress,
    displayName: PlaybookExecutionStatus.inProgress,
    filterType: FilterTypesEnum.ExecutionStatus,
    categoryName: FilterTypesEnum.ExecutionStatus,
  },
];
